<template>
  <div class="zbCardLists">
    <div class="wrap">
      <el-scrollbar style="height:100%;overflow-y: hidden;">
        <el-card class="box-card">
          <div
            v-for="o in 14"
            :key="o"
            class="text item"
            @click="clickNodeZb(o)"
          >
            {{ '指标 ' + o }}
          </div>
        </el-card>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZbCardLists',
  inject: ['getGraph', 'getNode'],
  data () {
    return {
      node: ''
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    clickNodeZb (o) {
      let node = this.getNode()
      console.log(node)
      let isZb = node.data.nodeType === 1 ? 'zbDrawer' : ''
      this.$bus.$emit('testNode', isZb, 2)
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.zbCardLists
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 12px 0px;
.wrap
  height: 200px
  overflow-y: hidden
  .item
    border 1px solid #ccc
    border-radius: 10px
    height 40px
    display flex
    justify-content center
    align-items center
    cursor pointer
  .item+.item
    margin-top: 20px

.wrap
  >>> .el-scrollbar__wrap
        height 109%
        border-left: 5px solid #ccc
</style>
